export default __webpack_public_path__ + "static/media/sunsculpted8.0077889e.jpg";